module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-7-35739eedc074669c668827c4e3bb0703.png";